import { Button, Modal, Spinner } from "flowbite-react";
import { FC } from "react";
import styled from "styled-components";
import { FormStateType } from "../../enums";
import CodeUtil from "../../utils/CodeUtil";
import ErrorBadge from "../ErrorBadge";
import FlatButton from "../FlatButton";
import { FormStateTag } from "../FormStateTag";
import { ModalFormProps } from "./types";

export const ModalForm: FC<ModalFormProps> = (props) => {
    const [disableSave] = props.disableSave ?? [undefined, undefined];

    if (!props.show) return <></>

    return (
        <form action="" method="post">
            <Modal size={props.size} show={props.show} onClose={props.onClose}>
                <Modal.Header>
                    <span className="text-lg font-semibold text-left text-gray-900">{props.title}</span>
                </Modal.Header>

                <div>
                    <div className={CodeUtil.arrayLength(props.errors, true) > 0 ? "p-6" : ""}>
                        <ErrorBadge errors={props.errors} />
                    </div>

                    <StyledModalBody $overflow={props.overflow} className={(props.fit ?? false) ? "m-0 p-0" : "px-2"}>
                        {props.children}
                    </StyledModalBody>
                </div>

                <footer className="p-3 border-t-2 flex justify-center items-center">
                    <div className="mr-auto">
                        <FormStateTag tag={props.state} />
                    </div>

                    <div className="inline-flex space-x-2 ml-auto">
                        <FlatButton onClick={props.onClose} label="Fechar" disabled={props.isSaving} />
                        {props.state === FormStateType.view && !props.selecao ? <></> :
                            <Button type="button" color="dark" size="sm" disabled={disableSave || props.isSaving} onClick={(e) => props.onSave?.call(this, e)}>
                                <div className={(props.isSaving ?? false) ? "mr-3 text-white" : "text-white"}>
                                    <Spinner size="sm" light={true} hidden={!(props.isSaving ?? false)} />
                                </div>
                                {props.saveButtonTitle ?? 'Gravar'}
                            </Button>
                        }
                    </div>
                </footer>
            </Modal>
        </form>
    );
};

const StyledModalBody = styled.div<{ $overflow?: string }>`
    overflow-y: ${props => props.$overflow ?? 'auto'};
    max-height: 60vh;
`

export default ModalForm;